import React, { useState, useEffect } from 'react';
import type { LoyaltyReward } from '../../types';

interface RewardModalProps {
  reward: LoyaltyReward | null;
  onClose: () => void;
  onSave: (reward: LoyaltyReward) => void;
}

const RewardModal: React.FC<RewardModalProps> = ({ reward, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    pointsRequired: 0,
    discountValue: 0,
  });
  const [id, setId] = useState<number | null>(null);

  useEffect(() => {
    if (reward) {
      setFormData({
        name: reward.name,
        pointsRequired: reward.pointsRequired,
        discountValue: reward.discountValue,
      });
      setId(reward.id);
    } else {
      setFormData({ name: '', pointsRequired: 100, discountValue: 5 });
      setId(null);
    }
  }, [reward]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: parseFloat(value) || value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.name || formData.pointsRequired <= 0 || formData.discountValue <= 0) {
      alert('Please provide a valid name, required points (> 0), and discount value (> 0).');
      return;
    }
    onSave({ ...formData, id: id || 0 });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
      <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">{reward ? 'Edit Reward' : 'Add New Reward'}</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Reward Name</label>
            <input type="text" name="name" id="name" value={formData.name} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-900 focus:outline-none focus:ring-pink-500 focus:border-pink-500" required />
          </div>
          <div className="mb-4">
            <label htmlFor="pointsRequired" className="block text-sm font-medium text-gray-700 mb-1">Points Required</label>
            <input type="number" name="pointsRequired" id="pointsRequired" value={formData.pointsRequired} onChange={handleChange} min="1" className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-900 focus:outline-none focus:ring-pink-500 focus:border-pink-500" required />
          </div>
          <div className="mb-6">
            <label htmlFor="discountValue" className="block text-sm font-medium text-gray-700 mb-1">Discount Value ($)</label>
            <input type="number" name="discountValue" id="discountValue" value={formData.discountValue} onChange={handleChange} min="0.01" step="0.01" className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-900 focus:outline-none focus:ring-pink-500 focus:border-pink-500" required />
          </div>
          <div className="flex justify-end space-x-4">
            <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">Cancel</button>
            <button type="submit" className="px-4 py-2 bg-pink-500 text-white rounded-md hover:bg-pink-600">Save Reward</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RewardModal;